"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTimestampStringToDate = transformTimestampStringToDate;
function transformTimestampStringToDate(timestampString) {
    return timestampString ? new Date(parseInt(timestampString, 10)) : undefined;
}
//# sourceMappingURL=transformTimestampStringToDate.js.map